import Report from 'garaje/models/report';
import _defaults from 'lodash/defaults';

export default class ConditionalRule extends Report {
  declare reason: string | null;

  constructor(attrs: Partial<ConditionalRule> = {}) {
    super(attrs);
    const props = { ...attrs };
    _defaults(props, {
      reason: null,
    });
    Object.assign(this, props);
  }
}
